<template>
  <nav class="type-400 text-uppercase mb-4">
    <ol class="breadcrumbs d-flex flex-wrap p-0 m-0" v-if="navItems.length">
      <li
        v-for="(label, index) in breadcrumbs"
        v-text="label"
        :key="index"
      />
    </ol>
    <span v-else class="loading-skeleton d-flex">
      <span class="load-box skel-300 px-5 rounded">
        Loading...
      </span>
    </span>
  </nav>
</template>

<script setup>
import { useNavItem } from '~/composables/useNavItem'
import { useApplicationConfigStore } from '~/store/application-config'
import { storeToRefs } from 'pinia'

const { navItems } = storeToRefs(useApplicationConfigStore())
const { currentActiveTopLevelLabel, currentActiveVisibleChildLabel } = useNavItem()

const breadcrumbs = computed(() => {
  if (!currentActiveTopLevelLabel.value && !currentActiveVisibleChildLabel.value) {
    return []
  }

  const _breadcrumbs = []
  const topLevelLabel = currentActiveTopLevelLabel.value
  const visibleChildLabel = currentActiveVisibleChildLabel.value

  if (topLevelLabel !== '') {
    _breadcrumbs.push(topLevelLabel)
  }
  if (visibleChildLabel !== '') {
    _breadcrumbs.push(visibleChildLabel)
  }

  return _breadcrumbs
})
</script>

<style lang="scss" scoped>
.load-box {
  height: 21px;
}
.breadcrumbs {
  list-style: none;
  font-size: 0.875rem;
  font-weight: 300;
}
.breadcrumbs li:not(:last-child)::after {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  content: '/';
}
</style>
